import { api } from "./client";

export type OfficeFilesStatus = {
  running?: boolean;
  state?: string;
  error?: string;
  need_files?: number;
  need_bytes?: number;
  global_files?: number;
  global_bytes?: number;
  errors?: number;
  peers_connected?: number;
};

export type OfficeFilesPC = {
  agent_id: string;
  name: string;
  is_server: boolean;
  enabled: boolean;
  online: boolean;
  supported: boolean;
  status: OfficeFilesStatus;
  status_at: string | null;
};

export type OfficeFilesOverview = {
  available: boolean;
  has_server_pc: boolean;
  folder_label: string;
  pcs: OfficeFilesPC[];
};

export async function getOfficeFiles() {
  const { data } = await api.get<OfficeFilesOverview>("/office-files/");
  return data;
}

export async function setOfficeFilesEnabled(agentId: string, enabled: boolean) {
  const { data } = await api.patch<{ agent_id: string; enabled: boolean }>(`/office-files/${agentId}`, {
    enabled,
  });
  return data;
}
